import {EntityService} from 'src/service/EntityService';

export class AgreementConfigService extends EntityService {
  static entity = 'iam-agreement-config';

  static getList(lazyLoadEvent: string, params?: any): Promise<any> {
    return super.getList(lazyLoadEvent, params);
  }

  static get(agreementPartyTypeConfId: string): Promise<any> {
    return super.get(agreementPartyTypeConfId);
  }

  static create(data: any): Promise<any> {
    return super.create(data);
  }

  static update(agreementConfigureEnumId: string, data: any): Promise<any> {
    return super.update(agreementConfigureEnumId, data);
  }

  static delete(agreementConfigureEnumId: string, params?: any): Promise<any> {
    return super.delete(agreementConfigureEnumId, params);
  }

  static saveItem(item: any): Promise<any> {
    return this.axios.post(`${this.entity}/item`, item);
  }

  static deleteItem(agreementConfigureEnumId: string, sequenceNum: number): Promise<any> {
    return this.axios.delete(`${this.entity}/item`, { params: { agreementConfigureEnumId, sequenceNum } });
  }

  static expire(agreementPartyTypeConfId: string): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementPartyTypeConfId}/expire`).then(res => res.data);
  }

  static activate(agreementPartyTypeConfId: string): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementPartyTypeConfId}/activate`).then(res => res.data);
  }

  static restore(agreementPartyTypeConfId: string): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementPartyTypeConfId}/restore`).then(res => res.data);
  }
}

